import * as actionTypes from './actionTypes'

export const loadWidgetSettings = (baseURL, wsBaseURL, companyAPIKey, strictPath, showCloseButton, style, user, password) => ({
    type: actionTypes.LOAD_WIDGET_SETTINGS,
    baseURL,
    wsBaseURL,
    companyAPIKey,
    strictPath,
    showCloseButton,
    style,
    user,
    password
});